import React from 'react';
import './../css/LandingPage.css';
import LandingDesign from './../images/landingPage.png';
import LDMobile from './../images/landingpgMobile.png';

const LandingPage = () => {
  return (
    <React.Fragment>
      <div className="container-fluid landing">
        <div className="row">
          <img
            src={LandingDesign}
            className="img-fluid LDlaptop"
            style={{ marginBottom: '-1%', width: '100%' }}
            alt="Landing Page Design"
          />
          <img
            src={LDMobile}
            className="img-fluid LDmobile"
            style={{ marginBottom: '-1%' }}
            alt="Landing Page Mobile Design"
          />
          <div className="social_icons">
            <a href="https://www.linkedin.com/in/likita-rai-09bb47199/">
              {' '}
              <i className="fa fa-linkedin-square" aria-hidden="true" id="home__social-link"></i>
            </a>
            <a href="https://github.com/likitarai1">
              {' '}
              <i className="fa fa-github" aria-hidden="true" id="home__social-link"></i>
            </a>
            <a href="mailto:likitarai1@gmail.com">
              {' '}
              <i className="fa fa-envelope" aria-hidden="true" id="home__social-link"></i>
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LandingPage;
